import React, {useState} from 'react';
import axios from "axios";
import a from './Form.module.scss'
import {useNavigate} from 'react-router-dom';

import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Подключите стили (если необходимо)

const ContactForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        gender: '',
        email: '',
        contactMethod: '',
        telegram: '',
        activity: '',
        blog: '',
        expertInstagram: '',
        telegramChannel: '',
        sellingProductOrService: {
            yes: false,
            no: false,
        },
        productDescription: '',
        earningFromAds: {
            yes: false,
            no: false,
        },
        currentEarnings: '',
        desiredEarnings: '',
        obstacles: '',
        agreeToTerms: true,
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        if (type === 'checkbox') {
            if (name === 'activity') {
                // Если выбран чекбокс "activity", устанавливаем его значение в state
                setFormData({
                    ...formData,
                    activity: value,
                });
            } else {
                // В противном случае, обрабатываем другие чекбоксы
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: {
                        ...prevData[name],
                        [value]: checked,
                    },
                }));
            }
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const renderInputForActivity = () => {
        // Определить, какой инпут нужно отображать в зависимости от выбранной деятельности
        switch (formData.activity) {
            case 'blogger':
                return (
                    <div>
                        <input
                            placeholder="ВАШ INSTAGRAM:"
                            type="text"
                            id="blog"
                            name="blog"
                            value={formData.blog}
                            onChange={handleChange}
                        />
                    </div>
                );
            case 'expert':
                return (
                    <div>
                        <input
                            placeholder="ВАШ INSTAGRAM:"
                            type="text"
                            id="expertInstagram"
                            name="expertInstagram"
                            value={formData.expertInstagram}
                            onChange={handleChange}
                        />
                    </div>
                );
            case 'admin':
                return (
                    <div>
                        <input
                            placeholder="ВАШ ТЕЛЕГРАМ КАНАЛ:"
                            type="text"
                            id="telegramChannel"
                            name="telegramChannel"
                            value={formData.telegramChannel}
                            onChange={handleChange}
                        />
                    </div>
                );
            default:
                return null; // Ничего не отображать по умолчанию
        }
    };

    const handleCheckboxChange = (name, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: {
                yes: value === "yes",
                no: value === "no",
            },
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true); // Включаем лоадер

            const response = await axios.post(`/api/send-email`, formData);

            if (response.status === 200) {
                // Данные успешно отправлены
                console.log('Данные успешно отправлены');
                setIsLoading(false); // Выключаем лоадер

                // Перенаправление на страницу "Успешно"
                navigate('/success');
            } else {
                // Произошла ошибка при отправке
                console.error('Произошла ошибка при отправке данных');
                setIsLoading(false); // Выключаем лоадер
            }
        } catch (error) {
            console.error('Произошла ошибка', error);
            setIsLoading(false); // Выключаем лоадер
        }
    };

    return (
        <div className={a.wrapperApp}>
            <div className={a.wrapperContent}>

                <div className={a.logoWrapper}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="318" height="22" viewBox="0 0 318 22" fill="none">
                        <path d="M7.962 5.94997H0V0.384212H22.9682V5.94997H15.0063V20.7829H7.962V5.94997Z"
                              fill="#AEDDFB"/>
                        <path
                            d="M45.2063 0.384212V5.37421H31.7379V7.92404H44.9335V12.8866H31.7379V15.6832H45.4048V20.7829H24.7929V0.384212H45.2063Z"
                            fill="#AEDDFB"/>
                        <path d="M54.4851 0.384212V14.9429H67.2838V20.7829H47.4408V0.384212H54.4851Z" fill="#AEDDFB"/>
                        <path
                            d="M89.5575 0.384212V5.37421H76.0891V7.92404H89.2847V12.8866H76.0891V15.6832H89.756V20.7829H69.1441V0.384212H89.5575Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M103.599 21.1667C101.912 21.1667 100.433 21.0113 99.1593 20.7006C97.9026 20.3899 96.8112 19.9786 95.8852 19.4668C94.9592 18.9367 94.1903 18.3336 93.5784 17.6573C92.9831 16.9627 92.5036 16.2316 92.1398 15.4639C91.776 14.6962 91.5197 13.9193 91.3709 13.1334C91.2221 12.3474 91.1477 11.598 91.1477 10.8851V10.1174C91.1477 9.38631 91.2138 8.62775 91.3461 7.84178C91.4949 7.05581 91.7512 6.28812 92.115 5.53871C92.4788 4.7893 92.9749 4.08558 93.6032 3.42756C94.2316 2.75126 95.0253 2.15721 95.9844 1.64542C96.96 1.13362 98.1175 0.731501 99.4569 0.439047C100.813 0.146593 102.4 0.000366211 104.219 0.000366211H105.187C107.072 0.000366211 108.692 0.128315 110.048 0.384212C111.421 0.640109 112.586 0.987397 113.545 1.42608C114.505 1.84648 115.273 2.33086 115.852 2.87921C116.447 3.40928 116.91 3.96677 117.241 4.55168C117.588 5.13659 117.82 5.72149 117.936 6.3064C118.051 6.87303 118.118 7.39396 118.134 7.8692V7.89662H110.792C110.759 7.76867 110.668 7.56761 110.519 7.29343C110.387 7.00098 110.114 6.70853 109.701 6.41607C109.287 6.12362 108.692 5.86772 107.915 5.64838C107.154 5.42904 106.121 5.31937 104.815 5.31937C103.574 5.31937 102.541 5.45646 101.714 5.73063C100.904 6.00481 100.251 6.37952 99.7546 6.85475C99.275 7.31171 98.936 7.84178 98.7376 8.44497C98.5392 9.04816 98.44 9.6879 98.44 10.3642V10.6658C98.44 11.3238 98.5557 11.9636 98.7872 12.585C99.0187 13.1882 99.3825 13.7366 99.8786 14.2301C100.391 14.7053 101.044 15.0892 101.838 15.3816C102.648 15.6741 103.624 15.8203 104.765 15.8203C105.955 15.8203 106.948 15.7198 107.741 15.5187C108.552 15.3176 109.205 15.08 109.701 14.8058C110.197 14.5134 110.544 14.2301 110.743 13.9559C110.958 13.6634 111.065 13.435 111.065 13.2705H104.591V9.29491H118.258V20.7829H113.818C113.785 20.6184 113.736 20.4173 113.669 20.1797C113.62 19.9238 113.554 19.6679 113.471 19.412C113.388 19.1378 113.297 18.8728 113.198 18.6169C113.116 18.361 113.033 18.1416 112.95 17.9589C112.768 18.1782 112.479 18.4707 112.082 18.8362C111.685 19.2018 111.139 19.5582 110.445 19.9055C109.75 20.2345 108.891 20.527 107.865 20.7829C106.84 21.0388 105.608 21.1667 104.17 21.1667H103.599Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M127.564 8.85623H135.65C136.427 8.85623 136.973 8.69173 137.287 8.36272C137.618 8.01543 137.783 7.59503 137.783 7.10151V7.07409C137.783 6.59886 137.626 6.19673 137.312 5.86772C136.998 5.52043 136.444 5.34679 135.65 5.34679H127.564V8.85623ZM127.564 20.7829H120.52V0.384212H137.287C139.982 0.384212 141.95 0.841172 143.19 1.75509C144.431 2.66901 145.051 3.95763 145.051 5.62096V5.92255C145.051 6.67197 144.918 7.31171 144.654 7.84178C144.406 8.37186 144.092 8.81968 143.711 9.18524C143.331 9.53253 142.926 9.81585 142.496 10.0352C142.066 10.2362 141.677 10.3825 141.33 10.4739C142.471 10.7663 143.389 11.3238 144.083 12.1463C144.778 12.9506 145.125 14.0107 145.125 15.3268V18.3427C145.125 19.0556 145.158 19.5765 145.224 19.9055C145.307 20.2162 145.39 20.463 145.472 20.6458V20.7829H138.279C138.197 20.6732 138.139 20.5452 138.106 20.399C138.073 20.2345 138.056 20.006 138.056 19.7136V17.3283C138.056 16.1584 137.775 15.2811 137.213 14.6962C136.667 14.093 135.7 13.7914 134.311 13.7914H127.564V20.7829Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M159.464 5.37421L156.437 12.3931H162.564L159.464 5.37421ZM164.821 17.4928H154.28L152.866 20.7829H145.722L154.85 0.384212H164.325L173.974 20.7829H166.26L164.821 17.4928Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M174.778 0.384212H184.451L190.107 11.8447L195.861 0.384212H205.138V20.7829H198.168V8.06112L191.694 20.7829H188.097L181.649 8.06112V20.7829H174.778V0.384212Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M219.68 5.37421L216.654 12.3931H222.781L219.68 5.37421ZM225.038 17.4928H214.496L213.083 20.7829H205.939L215.067 0.384212H224.542L234.191 20.7829H226.477L225.038 17.4928Z"
                            fill="#AEDDFB"/>
                        <path d="M238.559 5.94997H230.597V0.384212H253.565V5.94997H245.603V20.7829H238.559V5.94997Z"
                              fill="#AEDDFB"/>
                        <path d="M262.409 20.7829H255.39V0.384212H262.409V20.7829Z" fill="#AEDDFB"/>
                        <path
                            d="M277.215 21.1667C275.33 21.1667 273.693 21.0022 272.304 20.6732C270.931 20.3442 269.757 19.9146 268.782 19.3846C267.823 18.8362 267.037 18.2056 266.425 17.4928C265.83 16.7799 265.359 16.0488 265.012 15.2994C264.681 14.5317 264.458 13.7731 264.342 13.0237C264.226 12.256 264.168 11.5523 264.168 10.9125V10.1174C264.168 9.4777 264.218 8.78312 264.317 8.03371C264.433 7.26602 264.656 6.50746 264.987 5.75805C265.317 5.00864 265.78 4.28664 266.376 3.59206C266.971 2.89749 267.748 2.28516 268.707 1.75509C269.683 1.22502 270.865 0.804613 272.254 0.493882C273.643 0.164871 275.297 0.000366211 277.215 0.000366211H278.182C280.051 0.000366211 281.663 0.146593 283.019 0.439047C284.391 0.713222 285.549 1.08793 286.492 1.56317C287.451 2.02012 288.22 2.5502 288.798 3.15338C289.394 3.73829 289.857 4.34148 290.187 4.96294C290.518 5.56613 290.741 6.16017 290.857 6.74508C290.973 7.31171 291.031 7.81437 291.031 8.25305V8.60947H283.714C283.68 8.48153 283.598 8.24391 283.465 7.89662C283.333 7.54933 283.052 7.20204 282.622 6.85475C282.209 6.48919 281.605 6.16931 280.811 5.89514C280.034 5.62096 278.976 5.48388 277.637 5.48388C276.363 5.48388 275.322 5.6301 274.511 5.92255C273.718 6.19673 273.089 6.5623 272.626 7.01926C272.18 7.47622 271.874 7.98801 271.708 8.55464C271.543 9.12127 271.46 9.6879 271.46 10.2545V10.5835C271.46 11.1319 271.551 11.7077 271.733 12.3108C271.915 12.8958 272.238 13.4441 272.701 13.9559C273.164 14.4494 273.792 14.8607 274.586 15.1897C275.396 15.5004 276.421 15.6558 277.661 15.6558C278.571 15.6558 279.348 15.5827 279.993 15.4364C280.638 15.2902 281.184 15.1074 281.63 14.8881C282.076 14.6688 282.432 14.4311 282.697 14.1752C282.961 13.9011 283.168 13.6452 283.317 13.4075C283.465 13.1516 283.565 12.9232 283.614 12.7221C283.68 12.521 283.722 12.384 283.738 12.3108H291.031V12.7495C291.031 13.1882 290.973 13.7091 290.857 14.3123C290.741 14.8972 290.51 15.5004 290.162 16.1219C289.832 16.7433 289.369 17.3557 288.773 17.9589C288.178 18.562 287.401 19.1013 286.442 19.5765C285.499 20.0517 284.35 20.4356 282.994 20.728C281.638 21.0205 280.034 21.1667 278.182 21.1667H277.215Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M303.49 5.37421L300.464 12.3931H306.59L303.49 5.37421ZM308.847 17.4928H298.306L296.892 20.7829H289.749L298.876 0.384212H308.351L318 20.7829H310.286L308.847 17.4928Z"
                            fill="#AEDDFB"/>
                    </svg>
                </div>

                <p className={a.infoText}>Погрузитесь в первый профессиональный курс по продвижению
                    и продажам в Telegram. Со мной вы сможете выстроить полноценный бизнес и процессы продаж на
                    платформе.
                </p>

                <div className={a.colorBlock}>
                    После обучения вы с легкостью сможете:
                </div>

                <div className={a.pointsText}>
                    <p>делать качественные прогревы и инфоповоды</p>
                    <p>начать зарабатывать с рекламы</p>
                    <p>набирать целевую аудиторию без вложений</p>
                    <p>перегонять эффективно трафик из других соцсетей</p>
                    <p>освоить навыки продажи продуктов и услуг</p>
                </div>

                <div className={a.line}/>

                <div className={a.titleColor}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="320" height="27" viewBox="0 0 320 27" fill="none">
                        <path d="M0.566803 0.68001H30.5068V23H22.0168V6.62001H9.0868V23H0.566803V0.68001Z"
                              fill="#AEDDFB"/>
                        <path
                            d="M41.8135 16.01V23H33.2935V0.68001H51.8935C53.9535 0.68001 55.6635 0.87001 57.0235 1.25001C58.3835 1.63001 59.4635 2.16001 60.2635 2.84001C61.0835 3.50001 61.6535 4.28001 61.9735 5.18001C62.3135 6.08001 62.4835 7.04001 62.4835 8.06001V8.54001C62.4835 9.56001 62.3135 10.52 61.9735 11.42C61.6335 12.32 61.0535 13.11 60.2335 13.79C59.4335 14.47 58.3535 15.01 56.9935 15.41C55.6335 15.81 53.9335 16.01 51.8935 16.01H41.8135ZM41.8135 10.43H50.8735C51.8535 10.43 52.5635 10.25 53.0035 9.89001C53.4635 9.51001 53.6935 9.01001 53.6935 8.39001V8.30001C53.6935 7.66001 53.4735 7.16001 53.0335 6.80001C52.5935 6.44001 51.8735 6.26001 50.8735 6.26001H41.8135V10.43Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M88.921 0.68001V6.14001H72.631V8.93001H88.591V14.36H72.631V17.42H89.161V23H64.231V0.68001H88.921Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M93.0978 17.06C93.4178 16.44 93.6778 15.7 93.8778 14.84C94.0778 13.98 94.2378 12.91 94.3578 11.63C94.4778 10.35 94.5578 8.82001 94.5978 7.04001C94.6378 5.26001 94.6578 3.14001 94.6578 0.68001H120.608V17.06H124.208V26.9H116.198V23H98.1678V26.9H90.1578V17.06H93.0978ZM112.088 17.06V6.62001H102.338C102.338 7.76001 102.308 8.85001 102.248 9.89001C102.188 10.93 102.098 11.9 101.978 12.8C101.878 13.7 101.748 14.52 101.588 15.26C101.428 15.98 101.228 16.58 100.988 17.06H112.088Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M155.934 16.19C155.934 17.15 155.714 18.06 155.274 18.92C154.834 19.78 154.054 20.54 152.934 21.2C151.834 21.84 150.344 22.36 148.464 22.76C146.604 23.14 144.234 23.33 141.354 23.33H139.944C135.084 23.33 131.384 22.62 128.844 21.2C126.324 19.76 125.064 17.67 125.064 14.93V14.48H133.884C133.924 15.56 134.494 16.39 135.594 16.97C136.714 17.53 138.474 17.81 140.874 17.81C143.114 17.81 144.694 17.64 145.614 17.3C146.554 16.94 147.024 16.45 147.024 15.83V15.74C147.024 15.12 146.624 14.68 145.824 14.42C145.024 14.14 143.814 14 142.194 14H135.624V8.90001H142.194C143.694 8.90001 144.794 8.79001 145.494 8.57001C146.214 8.35001 146.574 7.98001 146.574 7.46001V7.37001C146.574 6.83001 146.114 6.42001 145.194 6.14001C144.274 5.86001 142.784 5.72001 140.724 5.72001C139.744 5.72001 138.844 5.77001 138.024 5.87001C137.204 5.97001 136.494 6.14001 135.894 6.38001C135.294 6.62001 134.824 6.93001 134.484 7.31001C134.144 7.69001 133.964 8.16001 133.944 8.72001H125.124V8.24001C125.124 7.18001 125.404 6.18001 125.964 5.24001C126.544 4.28001 127.434 3.44001 128.634 2.72001C129.834 2.00001 131.354 1.43001 133.194 1.01001C135.054 0.59001 137.254 0.38001 139.794 0.38001H141.144C143.904 0.38001 146.184 0.54001 147.984 0.860009C149.804 1.16001 151.244 1.58001 152.304 2.12001C153.384 2.64001 154.134 3.25001 154.554 3.95001C154.994 4.63001 155.214 5.35001 155.214 6.11001V6.38001C155.214 7.50001 154.744 8.48001 153.804 9.32001C152.884 10.16 151.524 10.67 149.724 10.85C151.724 11.05 153.254 11.61 154.314 12.53C155.394 13.45 155.934 14.57 155.934 15.89V16.19Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M171.978 6.14001L168.318 13.82H175.728L171.978 6.14001ZM178.458 19.4H165.708L163.998 23H155.358L166.398 0.68001H177.858L189.528 23H180.198L178.458 19.4Z"
                            fill="#AEDDFB"/>
                        <path d="M190.205 0.68001H220.145V23H211.655V6.62001H198.725V23H190.205V0.68001Z"
                              fill="#AEDDFB"/>
                        <path
                            d="M245.372 8.99001L231.362 23H222.842V0.68001H231.362V14.72L245.372 0.68001H253.892V23H245.372V8.99001Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M271.712 23.42C269.432 23.42 267.452 23.24 265.772 22.88C264.112 22.52 262.692 22.05 261.512 21.47C260.352 20.87 259.402 20.18 258.662 19.4C257.942 18.62 257.372 17.82 256.952 17C256.552 16.16 256.282 15.33 256.142 14.51C256.002 13.67 255.932 12.9 255.932 12.2V11.33C255.932 10.63 255.992 9.87001 256.112 9.05001C256.252 8.21001 256.522 7.38001 256.922 6.56001C257.322 5.74001 257.882 4.95001 258.602 4.19001C259.322 3.43001 260.262 2.76001 261.422 2.18001C262.602 1.60001 264.032 1.14001 265.712 0.80001C267.392 0.44001 269.392 0.26001 271.712 0.26001H272.882C275.142 0.26001 277.092 0.420009 278.732 0.740009C280.392 1.04001 281.792 1.45001 282.932 1.97001C284.092 2.47001 285.022 3.05001 285.722 3.71001C286.442 4.35001 287.002 5.01001 287.402 5.69001C287.802 6.35001 288.072 7.00001 288.212 7.64001C288.352 8.26001 288.422 8.81001 288.422 9.29001V9.68001H279.572C279.532 9.54001 279.432 9.28001 279.272 8.90001C279.112 8.52001 278.772 8.14001 278.252 7.76001C277.752 7.36001 277.022 7.01001 276.062 6.71001C275.122 6.41001 273.842 6.26001 272.222 6.26001C270.682 6.26001 269.422 6.42001 268.442 6.74001C267.482 7.04001 266.722 7.44001 266.162 7.94001C265.622 8.44001 265.252 9.00001 265.052 9.62001C264.852 10.24 264.752 10.86 264.752 11.48V11.84C264.752 12.44 264.862 13.07 265.082 13.73C265.302 14.37 265.692 14.97 266.252 15.53C266.812 16.07 267.572 16.52 268.532 16.88C269.512 17.22 270.752 17.39 272.252 17.39C273.352 17.39 274.292 17.31 275.072 17.15C275.852 16.99 276.512 16.79 277.052 16.55C277.592 16.31 278.022 16.05 278.342 15.77C278.662 15.47 278.912 15.19 279.092 14.93C279.272 14.65 279.392 14.4 279.452 14.18C279.532 13.96 279.582 13.81 279.602 13.73H288.422V14.21C288.422 14.69 288.352 15.26 288.212 15.92C288.072 16.56 287.792 17.22 287.372 17.9C286.972 18.58 286.412 19.25 285.692 19.91C284.972 20.57 284.032 21.16 282.872 21.68C281.732 22.2 280.342 22.62 278.702 22.94C277.062 23.26 275.122 23.42 272.882 23.42H271.712Z"
                            fill="#AEDDFB"/>
                        <path
                            d="M308.106 7.25001C310.346 7.25001 312.196 7.45001 313.656 7.85001C315.116 8.25001 316.266 8.80001 317.106 9.50001C317.966 10.18 318.556 10.98 318.876 11.9C319.216 12.82 319.386 13.8 319.386 14.84V15.32C319.386 16.36 319.216 17.35 318.876 18.29C318.556 19.21 317.976 20.02 317.136 20.72C316.296 21.42 315.146 21.98 313.686 22.4C312.226 22.8 310.366 23 308.106 23H290.196V0.68001H298.716V7.25001H308.106ZM307.026 17.45C307.706 17.45 308.276 17.39 308.736 17.27C309.196 17.13 309.556 16.96 309.816 16.76C310.096 16.54 310.286 16.29 310.386 16.01C310.506 15.73 310.566 15.44 310.566 15.14V15.05C310.566 14.73 310.506 14.44 310.386 14.18C310.286 13.9 310.096 13.66 309.816 13.46C309.556 13.26 309.196 13.1 308.736 12.98C308.276 12.86 307.706 12.8 307.026 12.8H298.716V17.45H307.026Z"
                            fill="#AEDDFB"/>
                    </svg>
                </div>

                <form className={a.form} onSubmit={handleSubmit}>
                    <input
                        placeholder="ФИО"
                        type="text"
                        id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                    />

                    <div className={a.phoneWrapperInput}>
                        <ReactPhoneInput
                            inputProps={{
                                name: 'phoneNumber',
                                required: true,
                                className: 'phoneInput', // добавьте класс для стилизации
                            }}
                            country={'ru'} // Установите код страны по умолчанию, например, для России (ru)
                            value={formData.phoneNumber}
                            onChange={(value, country, e, formattedValue) => {
                                // Обновите состояние формы с учетом выбранного номера телефона
                                handleChange({
                                    target: {
                                        name: 'phoneNumber',
                                        value: formattedValue,
                                    },
                                });
                            }}
                        />
                    </div>

                    <div className={a.genderWrapper}>
                        <select
                            id="gender"
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            required
                        >
                            <option value="">ВЫБЕРИТЕ ПОЛ</option>
                            <option value="Мужской">Мужской</option>
                            <option value="Женский">Женский</option>
                            <option value="X">X</option>
                        </select>
                    </div>

                    <input
                        placeholder="E-MAIL"
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <select
                        id="contactMethod"
                        name="contactMethod"
                        value={formData.contactMethod}
                        onChange={handleChange}
                    >
                        <option value="">КОМФОРТНЫЙ СПОСОБ СВЯЗИ</option>
                        <option value="Телефон">Телефон</option>
                        <option value="Email">Email</option>
                        <option value="Telegram">Telegram</option>
                    </select>

                    {formData.contactMethod === 'Telegram' && ( // Показать дополнительное поле только при выборе 'Админ Telegram'
                        <input
                            placeholder="ВАШ ТЕЛЕГРАМ"
                            type="text"
                            id="telegram"
                            name="telegram"
                            value={formData.telegram}
                            onChange={handleChange}
                        />
                    )}

                    <div className={a.outlineBlock}>
                        <p className={a.titleOutlineBlock}>ГЛАВНЫЙ КУРАТОР КУРСА – МИЛАНА ПЕТРОВА</p>
                        <p className={a.subtitleOutlineBlock}>СОЗДАТЕЛЬНИЦА СЕТКИ TELEGRAM-КАНАЛОВ С ЕЖЕМЕСЯЧНОЙ <br/>
                            ДОХОДНОСТЬЮ В 6,5 МЛН СУММАРНО</p>
                    </div>

                    <div className={`${a.colorBlock} ${a.two}`}>
                        Я научу вас:
                    </div>

                    <div className={a.pointsText}>
                        <p>создавать вирусный контент</p>
                        <p>прогревать и продавать в telegram</p>
                        <p>набирать аудиторию бесплатными методами продвижения</p>
                    </div>

                    <p className={a.authorText}>
                        ПОЛУЧИТЕ АВТОРСКУЮ МЕТОДИКУ ПО ПРОДВИЖЕНИЮ
                        И МОНЕТИЗАЦИИ TELEGRAM-КАНАЛОВ
                    </p>

                    <div className={a.quaWrapper}>
                        <label className={a.questionTitle}>Ваша деятельность:</label>
                        <div className={a.inlineCheckbox}>
                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="radio"
                                    id="blogger"
                                    name="activity"
                                    value="blogger"
                                    checked={formData.activity === 'blogger'}
                                    onChange={handleChange}
                                />
                                <label htmlFor="blogger">Блогер Instagram</label>
                            </div>

                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="radio"
                                    id="expert"
                                    name="activity"
                                    value="expert"
                                    checked={formData.activity === 'expert'}
                                    onChange={handleChange}
                                />
                                <label htmlFor="expert">Эксперт Instagram</label>
                            </div>

                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="radio"
                                    id="admin"
                                    name="activity"
                                    value="admin"
                                    checked={formData.activity === 'admin'}
                                    onChange={handleChange}
                                />
                                <label htmlFor="admin">Админ Telegram</label>
                            </div>
                        </div>
                        {/* Отобразить соответствующий инпут */}
                        {renderInputForActivity()}
                    </div>

                    <div className={a.quaWrapper}>
                        <label className={a.questionTitle}>Вы продаете продукт или услугу?</label>
                        <div className={a.inlineCheckbox}>
                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="checkbox"
                                    id="yesSelling"
                                    name="sellingProductOrService"
                                    value="yes"
                                    checked={formData.sellingProductOrService.yes}
                                    onChange={() => handleCheckboxChange("sellingProductOrService", "yes")}
                                />
                                <label htmlFor="yesSelling">Да</label>
                            </div>

                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="checkbox"
                                    id="noSelling"
                                    name="sellingProductOrService"
                                    value="no"
                                    checked={formData.sellingProductOrService.no}
                                    onChange={() => handleCheckboxChange("sellingProductOrService", "no")}
                                />
                                <label htmlFor="noSelling">Нет</label>
                            </div>
                        </div>

                        {formData.sellingProductOrService.yes && (
                            <div>
                                {/*<label htmlFor="productDescription">Опишите свой продукт:</label>*/}
                                <textarea
                                    placeholder="ОПИШИТЕ СВОЙ ПРОДУКТ"
                                    id="productDescription"
                                    name="productDescription"
                                    value={formData.productDescription}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                    </div>

                    <div className={a.quaWrapper}>
                        <label className={a.questionTitle}>Зарабатываете ли вы с рекламы?</label>
                        <div className={a.inlineCheckbox}>
                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="checkbox"
                                    id="yesEarningFromAds"
                                    name="earningFromAds"
                                    value="yes"
                                    checked={formData.earningFromAds.yes}
                                    onChange={() => handleCheckboxChange("earningFromAds", "yes")}
                                />
                                <label htmlFor="yesEarningFromAds">Да</label>
                            </div>

                            <div className={a.checkBoxWrapper}>
                                <input
                                    className={a.checkbox}
                                    type="checkbox"
                                    id="noEarningFromAds"
                                    name="earningFromAds"
                                    value="no"
                                    checked={formData.earningFromAds.no}
                                    onChange={() => handleCheckboxChange("earningFromAds", "no")}
                                />
                                <label htmlFor="noEarningFromAds">Нет</label>
                            </div>
                        </div>

                        <div className={a.cashWrapper}>
                            <input
                                placeholder="ДОХОД СЕЙЧАС"
                                type="text"
                                id="currentEarnings"
                                name="currentEarnings"
                                value={formData.currentEarnings}
                                onChange={handleChange}
                            />

                            <input
                                placeholder="ЖЕЛАЕМЫЙ ДОХОД"
                                type="text"
                                id="desiredEarnings"
                                name="desiredEarnings"
                                value={formData.desiredEarnings}
                                onChange={handleChange}
                            />
                        </div>

                        <div>
                            <textarea
                                placeholder="ЧТО МЕШАЕТ ЗАРАБАТЫВАТЬ ЖЕЛАЕМУЮ СУММУ?"
                                id="obstacles"
                                name="obstacles"
                                value={formData.obstacles}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                    </div>

                    <div className={a.buttonSumbitWrapper}>
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Отправка..." : "Отправить"}
                        </button>
                        <div className={a.checkBoxAgree}>
                            <input
                                type="checkbox"
                                id="agreeToTerms"
                                name="agreeToTerms"
                                defaultChecked={true}
                                checked={formData.agreeToTerms}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="agreeToTerms">
                                Нажимая на кнопку, вы соглашаетесь с&nbsp;
                                <a href="/Политика_обработки_персональных_данных.docx" download>
                                    условиями обработки персональных данных
                                </a>
                            </label>
                        </div>
                    </div>

                </form>
            </div>
            <footer>
                <div className={a.footerWrapper}>
                    {/*<p className={a.footerText}>*/}
                    {/*    Старт курса: 1 декабря*/}
                    {/*</p>*/}
                    {/*<p className={a.footerText}>*/}
                    {/*    Срок обучения: 2 месяца*/}
                    {/*</p>*/}
                    <p className={a.footerSecond}>
                        Для жителей РФ, РБ и Казахстан будет доступна беспроцентная рассрочка
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default ContactForm;